(() => {
  'use strict';
  if (!customElements.get('rnf-navigation')) {
    customElements.define('rnf-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.desktop = matchMedia('(min-width:990px)');
        this.motion = matchMedia('(prefers-reduced-motion:reduce)');
        this.disclosures = [...this.querySelectorAll('[data-rnf-unified-disclosure]')];
        this.timers = new Map();
        this.frames = new Map();
        this.header = this.closest('.header-wrapper');
        const reposition = () => this.disclosures.forEach(details => { if (details.open) this.position(details); });
        this.resizeObserver = new ResizeObserver(reposition);
        if (this.header) this.resizeObserver.observe(this.header);
        window.addEventListener('resize', reposition, { signal, passive: true });
        this.watches = this.querySelector('[data-rnf-watches-disclosure]');
        // Keep the original carousel controller responsible for watches. Coordinate only visibility.
        this.watches?.addEventListener('toggle', () => {
          if (this.watches.open) this.disclosures.forEach(details => this.close(details, true));
        }, { signal });
        this.disclosures.forEach(details => {
          const summary = details.querySelector('summary');
          details.setAttribute('data-rnf-menu-ready', '');
          summary.addEventListener('click', event => {
            if (!this.desktop.matches) return;
            event.preventDefault();
            if (details.open && !details.classList.contains('is-closing')) this.close(details);
            else this.open(details);
          }, { signal });
          // Click-open menus stay open while the pointer crosses the header-to-panel gap.
          details.addEventListener('focusout', event => {
            if (event.relatedTarget && !details.contains(event.relatedTarget)) this.close(details);
          }, { signal });
          summary.addEventListener('keydown', event => {
            if (event.key !== 'ArrowDown') return;
            event.preventDefault(); this.open(details); details.querySelector('a')?.focus();
          }, { signal });
          details.addEventListener('keydown', event => {
            if (event.key === 'Escape') { event.preventDefault(); this.close(details); summary.focus(); }
          }, { signal });
        });
        document.addEventListener('pointerdown', event => {
          this.disclosures.forEach(details => { if (!details.contains(event.target)) this.close(details); });
        }, { signal, passive: true });
        this.desktop.addEventListener('change', () => { if (!this.desktop.matches) this.disclosures.forEach(details => this.close(details, true)); }, { signal });
      }
      position(details) {
        if (!this.header || !this.desktop.matches) return;
        const header = this.header.getBoundingClientRect();
        const anchor = details.getBoundingClientRect();
        const panel = details.querySelector('.rnf-navigation-dropdown');
        details.style.setProperty('--rnf-menu-top', `${header.bottom - anchor.top}px`);
        details.style.setProperty('--rnf-menu-header-bottom', `${header.bottom}px`);
        const width = panel.getBoundingClientRect().width;
        const start = Math.max(header.left + 24, Math.min(anchor.left - 14, header.right - width - 24));
        details.style.setProperty('--rnf-menu-left', `${start - anchor.left}px`);
      }
      open(details) {
        if (this.watches?.open) {
          this.watches.open = false;
          this.watches.classList.remove('is-closing');
        }
        this.disclosures.forEach(other => { if (other !== details) this.close(other, true); });
        clearTimeout(this.timers.get(details)); this.timers.delete(details);
        cancelAnimationFrame(this.frames.get(details));
        details.classList.remove('is-closing'); details.open = true;
        this.position(details);
        if (this.motion.matches) details.classList.add('is-expanded');
        else this.frames.set(details, requestAnimationFrame(() => { details.classList.add('is-expanded'); this.frames.delete(details); }));
        details.querySelector('summary').setAttribute('aria-expanded', 'true');
      }
      close(details, immediate = false) {
        clearTimeout(this.timers.get(details));
        cancelAnimationFrame(this.frames.get(details)); this.frames.delete(details);
        if (!details.open) return;
        details.classList.remove('is-expanded');
        details.querySelector('summary').setAttribute('aria-expanded', 'false');
        const finish = () => { details.open = false; details.classList.remove('is-closing'); this.timers.delete(details); };
        if (immediate || this.motion.matches) finish();
        else { details.classList.add('is-closing'); this.timers.set(details, setTimeout(finish, 350)); }
      }
      disconnectedCallback() { this.controller?.abort(); this.controller=null; this.resizeObserver?.disconnect(); this.timers?.forEach(clearTimeout); this.frames?.forEach(cancelAnimationFrame); }
    });
  }
  // Use the store's existing Inbox launcher. If unavailable, the contact link remains usable.
  if (!document.documentElement.hasAttribute('data-rnf-chat-link-ready')) {
    document.documentElement.setAttribute('data-rnf-chat-link-ready', '');
    document.addEventListener('click', async event => {
      const link = event.target.closest?.('[data-rnf-chat-open]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const launcher = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('button[part="activator"]');
      if (!launcher) return;
      event.preventDefault();
      const menu = document.querySelector('rnf-mobile-menu');
      if (menu?.isOpen?.() || menu?.querySelector('dialog[open]')) await menu.close({ restoreFocus: false });
      const details = link.closest('details');
      const navigation = details?.closest('rnf-navigation');
      if (navigation?.close && details.hasAttribute('data-rnf-unified-disclosure')) navigation.close(details, true);
      else details?.removeAttribute('open');
      launcher.click();
    });
  }
})();




